import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {AmenitiesService} from '../../../services/amenities.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {ApiClientService} from '../../../services/api-client.service';
import {ResidentService} from '../../../services/resident.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'amenities-list',
    templateUrl: './amenities-list.component.html',
    styleUrls: ['./amenities-list.component.scss']
})
export class AmenitiesListComponent {

    constructor(
        public urlService: UrlService,
        public api: ApiClientService,
        public amenitiesService: AmenitiesService,
        public authenticationService: AuthenticationService,
        public residentService: ResidentService
    ) {
        console.log(this.amenitiesService);
    }

    orderBy(orderBy: string, $event) {
        if (this.amenitiesService.data.allAmenities.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showPaymentModal(event, booking) {
        event.showDropdown = true;
        this.toggleCheck(booking);
        setTimeout(() => this.amenitiesService.onPaymentTableAction.emit());
    }

    firstButton(item) {
        if(item.isCanEdit && item.status == 'declined')
            return 'edit';
        else if(item.isCanApprove && item.status == 'pending' && this.amenitiesService.allPaymentArePaid(item))
            return 'approve';
        else if(item.isCanEdit && item.status == 'pending' && !this.amenitiesService.allPaymentArePaid(item))
            return 'pay';
        else
            return 'view';
    }

    amenityIsAvailableToResident(booking): boolean {
        let isAvailable = false;

        if(booking.amenityId) {
            const matchedAmenity = this.amenitiesService.amenitiesList.find(a => a.id == booking.amenityId);
            if(matchedAmenity) {
                if(matchedAmenity.residentOccupancyTypes.length > 0) {
                    const residentRole = JSON.parse(localStorage.getItem('residentselectedBuilding')).residentRole;
                    isAvailable = matchedAmenity.residentOccupancyTypes.findIndex(o => o.code == residentRole) != -1;
                } else
                    isAvailable = true;
            }
        }

        return isAvailable;
    }

    toggleCheck(selectedItem): void {
        //Preventing the detailed view opening on mobile version.
        if(window.innerWidth <= 760) return;

        const checked = selectedItem.checked;
        this.amenitiesService.data.allAmenities.data.forEach(item => item.checked = false);
        if (checked && this.amenitiesService.selectedItemData) {
            this.amenitiesService.selectedItemData = null;
            this.amenitiesService.toggleDetailedView(null, false);
            selectedItem.checked = false;
        } else {
            this.amenitiesService.selectedItemData = null;
            this.amenitiesService.getBookingInfoById(selectedItem.id).subscribe(res => {
                selectedItem =  Object.assign(selectedItem, res);
                selectedItem.checked = true;
                this.amenitiesService.selectedItemData = selectedItem;
                this.amenitiesService.toggleDetailedView(selectedItem, true);
            });
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/amenities/amenities-list/amenities-list.component.ts